export default __webpack_public_path__ + "static/media/undraw_code_typing_7jnv.f91e2bd4.svg";